@if (loaded) {
  <p-tree
    [(selection)]="selection"
    [ariaLabel]="'CHOP_KATALOGE.BETRIEBSVARIABLEN' | translate"
    [filter]="true"
    [value]="treeNodes"
    class="w-full"
    filterPlaceholder=""
    scrollHeight="400px"
    selectionMode="checkbox"></p-tree>

  <div class="flex justify-content-end gap-2 mt-3">
    <p-button
      (onClick)="cancel()"
      [label]="'ACTIONS.CANCEL' | translate"
      [outlined]="true"
      severity="secondary"></p-button>
    <p-button
      (onClick)="onSubmit()"
      [disabled]="selection.length === 0"
      [label]="'ACTIONS.SAVE' | translate"
      [loading]="submitting"></p-button>
  </div>
}
